import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6280ea5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "heightarrow"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 调高 ")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 调低 ")
const _hoisted_7 = {
  key: 1,
  class: "heightarrow"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 调高 ")
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 调低 ")
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.theme !== 'dark')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createElementVNode("img", {
                    src: require('@/assets/top_light.png'),
                    alt: ""
                  }, null, 8, _hoisted_3),
                  _hoisted_4,
                  _createElementVNode("img", {
                    src: require('@/assets/bottom_light.png'),
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _hoisted_6
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("img", {
                    src: require('@/assets/top_light.png'),
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _hoisted_9,
                  _createElementVNode("img", {
                    src: require('@/assets/bottom_dark.png'),
                    alt: ""
                  }, null, 8, _hoisted_10),
                  _hoisted_11
                ])),
            _createVNode(_component_Table, {
              data: _ctx.data,
              columns: _ctx.columns,
              bordered: true,
              pagination: _ctx.total > 10 ? _ctx.pagination : false
            }, null, 8, ["data", "columns", "pagination"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _createVNode(_component_Nodata, { customdesc: '该股暂无预测明细' })
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}